import { createAction } from '@reduxjs/toolkit';

export const checkTokenRequestAction = createAction('CHECK_TOKEN_REQUEST');
export const formWireSaveRequestAction = createAction('SAVE_WIRE_FORM_REQUEST');
